import React, { useState, useEffect, useCallback } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";

import toastr from "toastr";

import {
    employeeToUserFieldRules,
    initialEmpToUserField,
} from "app/_pages/UserManagement/Employee/Constant";
import { RoleService } from "app/_services/RoleService/RoleService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { Validation } from "app/_helpers/validation/Validation";
import { employeeToUser } from "app/_services/UserManagement/EmployeeService";

import localStorageService from "app/services/localStorageService";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import {
    HO_Work_Flow_Role_List,
    MINE_Work_Flow_Role_List,
    RO_Work_Flow_Role_List,
    UserWorkFlowRoleList,
} from "app/_constants/constant";

function UserPermissionCheckbox({ form, onChange, title, siteType }) {
    const scopeRoles = (() => {
        const obj = {};

        let roles = [];

        switch (siteType) {
            case 1:
                roles = HO_Work_Flow_Role_List;
                break;
            case 2:
                roles = RO_Work_Flow_Role_List;
                break;
            case 3:
                roles = MINE_Work_Flow_Role_List;
                break;
            default:
                break;
        }
        roles.forEach((role) => {
            if (!obj[role.scope]) obj[role.scope] = [role];
            else obj[role.scope].push(role);
        });

        return Object.keys(obj).map((key) => ({
            title: key,
            roles: obj[key],
            col: obj[key].length === 1 ? 12 : 12,
        }));
    })();

    return (
        <div className="mt-3">
            <label className="mb-2">{title}</label>

            <hr style={{ background: "#ccc" }} className="mt-0 mb-4" />

            <div className="row mx-0">
                {scopeRoles.map(({ title: scopeTitle, roles, col }) => (
                    <div className={"mt-2 px-0 col-" + col}>
                        <h5 className="mb-0">{scopeTitle}</h5>

                        <Row>
                            <Col md={col === 6 ? 6 : 12}>
                                <hr className="mb-2 mt-0" />
                            </Col>
                            {roles.map((workRole) => (
                                <Col md={col === 6 ? 12 : 4} key={workRole.name}>
                                    <label className="checkbox checkbox-primary mb-4">
                                        <input
                                            type="checkbox"
                                            name={workRole.name}
                                            checked={form[workRole.name]}
                                            onChange={onChange}
                                        // disabled={!workRole[siteType]}
                                        />
                                        <span
                                        // className={!workRole[siteType] ? "text-light" : ""}
                                        >
                                            {workRole.label}
                                        </span>
                                        <span className="checkmark"></span>
                                    </label>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default UserPermissionCheckbox;